import './style.sass';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import dynamic from 'next/dynamic';

const AnimatedLottie = dynamic(() => import('../lottie'), { ssr: false });

type SolutionPropsType = {
    list: { description: string }[];
    listRoles: { description: string }[];
};
const Solution = ({ list, listRoles }: SolutionPropsType) => {
    return (
        <div className="aimed-solution">
            <FullWrapper isMargin={false} className="aimed-solutionCase">
                <div className="aimed-solutionWrapper">
                    <div className="aimed-solutionTitle">Решение</div>
                    <div className="aimed-solutionInner">
                        <div className="aimed-solutionLeft">
                            <div className="aimed-solutionDescription">
                                Наша команда с&nbsp;нуля продумала и&nbsp;разработала
                                технологическое программное решение для проведения двух конкурсов
                                с&nbsp;разными механиками. Аналогов данного ИТ-решения не&nbsp;было.
                            </div>
                            <div className="aimed-solutionPirpleBlock">
                                <div className="aimed-solutionPirpleParagraf">
                                    На&nbsp;первом этапе продумали архитектуру платформы, создали
                                    дизайн-макеты, прописали функциональные требования
                                    и&nbsp;спроектировали личные кабинеты для 8&nbsp;ролей
                                    пользователей (участник, эксперт-медик, администратор
                                    и&nbsp;т.&nbsp;д.)
                                </div>
                            </div>
                        </div>
                        <div className="aimed-solutionRight">
                            Общие требования к&nbsp;платформе&nbsp;&mdash; высокая
                            отказоустойчивость и&nbsp;принцип&nbsp;открытого кода
                            для&nbsp;обеспечения прозрачности испытаний.
                        </div>
                    </div>
                    <div className="aimed-solutionInner">
                        <div className="aimed-solutionLeft">
                            <div className="aimed-solutionList">
                                {list &&
                                    list.map(item => (
                                        <div
                                            key={item.description}
                                            dangerouslySetInnerHTML={{ __html: item.description }}
                                            className="aimed-solutionParagraf"
                                        ></div>
                                    ))}
                            </div>
                        </div>
                    </div>
                    <div className="aimed-solutionRelationship">
                        <div className="aimed-solutionSubtitle">
                            Взаимодействие ролей на&nbsp;проекте
                        </div>
                        <div className="aimed-solutionLottie">
                            <AnimatedLottie />
                        </div>
                        <div className="aimed-solutionPirpleBlock">
                            <div className="aimed-solutionPirpleParagraf">
                                На&nbsp;втором этапе, за&nbsp;4&nbsp;месяца, разработали основные
                                модули и&nbsp;элементы платформы, загрузили все медицинские
                                информационные базы, которые нужны для проведения конкурсов.
                            </div>
                        </div>
                        <div className="aimed-solutionList">
                            {listRoles &&
                                listRoles.map(item => (
                                    <div
                                        key={item.description}
                                        dangerouslySetInnerHTML={{ __html: item.description }}
                                        className="aimed-solutionParagraf"
                                    ></div>
                                ))}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Solution;
